import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { useGetDataOnScroll } from "../getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetCompanyListQuery } from "../../redux/api/chemicalization/companyApi";
import { EntCompany } from "../../models/chemicalization/company";
import { EntCompanyFilter } from "../../models/filters/companyFilter";

interface IProps {
  onChange?: (value: number) => void;
  value?: number | null;
}

const SelectCompany = (props: IProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<ISelectOption[]>([]);

  const [ getArchiveFolders ] = useLazyGetCompanyListQuery();
  const {
	fetching,
	data,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntCompany, EntCompanyFilter>({
	initialFilter: new EntCompanyFilter(),
	query: getArchiveFolders
  });

  useEffect(() => {
	const options = Array.from(new Set(data)).map((a) => {
	  return { label: a.companyName ?? '', value: a.id ?? '' };
	});
	setOptions(options);
  }, [data]);

  const search = (value?: string) => {
	if (!value) return;
	const filter = new EntCompanyFilter();
	filter.companyName = value;
	setFilter(filter);
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }
  const clear = () => {
	const filter = new EntCompanyFilter();
	filter.companyName = null;
	setFilter(filter);
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  return (
	<Select
	  placeholder={t("msg.selectPlaceholder")}
	  onClear={clear}
	  onSearch={search}
	  onPopupScroll={scrollHandler}
	  loading={fetching}
	  value={props.value}
	  onChange={props.onChange}
	  options={options}
	  filterOption={defaultFilterOption}
	  showSearch
	  allowClear
	  dropdownRender={(menu) => (
		<Spin spinning={fetching}>
		  {menu}
		</Spin>
	  )}
	/>
  );
};

export default SelectCompany;